<template>
    <div name="address-modal" class="modal">
        
        <confirm-modal 
            @onClose="closeConfirmModal"
            @onYes="yesConfirmModal"
            v-if="isConfirmModal"
        />
        <div class="touch" @click="onClose">

        </div>
        <div class="contents">
            <span class="title">{{isUpdate ? '배송지 수정' : '배송지 등록'}} </span>
            <div class="row" style="margin-top: 20px;">                
                <input v-model="address" 
                    v-focus-input-style
                    style="background-color: var(--Gray-20, #F3F5F8); width: calc(100% - 100px); color: #000;"
                    ref="address"
                    class="input-big"
                    placeholder="주소 검색"
                    disabled
                />
                <div class="search-address-button" @click="searchAddress">주소 찾기</div>
            </div>
            <div class="error-info-text" v-if="isAddressError" >주소를 입력해 주세요.</div>
            <input v-model="detailAddress" 
                v-focus-input-style
                style="background-color: var(--Gray-20, #F3F5F8);margin-top: 16px;color: #000;"
                ref="detailAddress"
                class="input-big"
                placeholder="상세 주소 (필수)"
            />
            <div class="error-info-text" v-if="isDetailAddressError">상세 주소를 입력해 주세요.</div>
            <input v-model="addressNickname" 
                v-focus-input-style
                style="background-color: var(--Gray-20, #F3F5F8);margin-top: 16px;color: #000;"
                ref="addressNickname"
                class="input-big"
                placeholder="배송받는 분 (필수)"
            />
            <div class="error-info-text" v-if="isAddressNicknameError">배송받는 분을 입력해 주세요.</div>
            <input v-model="addressDescription" 
                v-focus-input-style
                style="background-color: var(--Gray-20, #F3F5F8);margin-top: 16px;color: #000;"
                ref="addressDescription"
                class="input-big"
                placeholder="배송 메시지 입력 (선택)"
            />
            <div class="info-text" >배송 메시지는 배송기사님께 전달됩니다.</div>
            <div class="apply" style="margin-top: 40px;" @click="apply">{{isUpdate ? '배송지 수정하기' : '배송지 등록하기'}}</div>
            <div class="cancel" @click="onClose">취소하기</div>
        </div>

        <div class="postcode-layer" v-if="isPostcodeOpen">
            <div class="postcode-header">
                <span class="postcode-title">주소 검색</span>
                <img class="postcode-close" src="../../assets/close.png" @click="closePostcode" />
            </div>
            <div class="postcode-embed" ref="postcodeEmbed"></div>
        </div>
    </div>
</template>

<script>
import focusInputStyle from '@/components/directives/focusInputStyle';
import ConfirmModal from '@/components/modals/ConfirmModal';

export default {
  components: { ConfirmModal },
    name: 'addressModal',
    directives: {
        focusInputStyle
    },
    props: ['preAddress', 'preZipCode', 'preDetailAddress', 'preAddressNickname', 'preAddressDescription', 'isUpdate'],
    data: function()
    {
        return {
            address: "",
            zipCode: "",
            detailAddress: "",
            addressNickname: "",
            addressDescription: "",
            isAddressError: false,
            isDetailAddressError: false,
            isAddressNicknameError: false,
            isConfirmModal: false,
            isPostcodeOpen: false
        }
    },
    mounted: function()
    {  
        if(this.isUpdate)
        {
            this.address = this.preAddress;
            this.zipCode = this.preZipCode;
            this.detailAddress = this.preDetailAddress;
            this.addressNickname = this.preAddressNickname
            if(this.preAddressDescription === null)
            {
                this.addressDescription = "";
            }
            else
            {
                this.addressDescription = this.preAddressDescription;
            }
        }

    },
    methods: {
        searchAddress: function()
        {
            if(this.isPostcodeOpen)
            {
                return;
            }

            var _this = this;
            this.isPostcodeOpen = true;

            // embed 대상이 화면에 그려진 뒤에 삽입해야 iframe 높이가 잡힙니다.
            this.$nextTick(function()
            {
                if(!_this.$refs.postcodeEmbed)
                {
                    return;
                }

                new kakao.Postcode({
                    oncomplete: function(data) {
                        // 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분입니다.
                        _this.address = data.address;
                        _this.zipCode = data.zonecode;
                        _this.closePostcode();
                    },
                    onclose: function() {
                        _this.closePostcode();
                    },
                    width: '100%',
                    height: '100%'
                }).embed(_this.$refs.postcodeEmbed);
            });
        },
        closePostcode: function()
        {
            this.isPostcodeOpen = false;
        },
        onClose: function()
        {
            if(this.address !== null && this.address !== '')
            {
                this.isConfirmModal = true;
                return;
            }

            if(this.detailAddress !== null && this.detailAddress !== '')
            {
                this.isConfirmModal = true;
                return;
            }

            if(this.addressNickname !== null && this.addressNickname !== '')
            {
                this.isConfirmModal = true;
                return;
            }
            this.$emit('onClose')
            
        },
        yesConfirmModal: function()
        {
            this.$emit('onClose')
        },
        closeConfirmModal: function()
        {
            this.isConfirmModal = false;
        },
        errorFocus: function(field)
        {
            this.$refs[field].style.border = '1.5px solid var(--Semantic-01_Red, #FF000F)';

            const offsetTop = this.$refs[field].offsetTop;
                window.scrollTo({
                    top: offsetTop - 50, // 50px 위로 조정
                    behavior: 'smooth'
            });
           
            // this.contentsSizeUpdate(22)
            if(field === 'address')
            {
                this.isAddressError = true;
            }
            else if(field === 'detailAddress')
            {
                this.isDetailAddressError = true;
            }
            else if(field === 'addressNickname')
            {
                this.isAddressNicknameError = true;
            }
        },
        contentsSizeUpdate: function(pixel)
        {
            const el = document.querySelector('.contents');
            el.style.height = `calc(${440.8 + pixel}px)`;

            const element = document.querySelector('.touch');       
            element.style.height = `calc(100vh - ${440.8 + pixel}px)`;
        },
        apply: function()
        {
            if(this.address === null || this.address === '')
            {
                this.errorFocus('address')
                return;
            }

            if(this.detailAddress === null || this.detailAddress === '')
            {
                this.errorFocus('detailAddress')
                return;
            }

            if(this.addressNickname === null || this.addressNickname === '')
            {
                this.errorFocus('addressNickname')
                return;
            }

            this.$emit('apply', this.address, this.detailAddress.trim(), this.addressNickname.trim(), this.zipCode, this.addressDescription.trim())
        }
    },
    watch: {
        address: function()
        {
            if(this.isAddressError)
            {
                this.isAddressError = false;
                this.$refs['address'].style.border = '0';
                // this.contentsSizeUpdate(-22)
            }
        },
        detailAddress: function()
        {
            if(this.detailAddress.length > 30)
            {
                this.detailAddress = this.detailAddress.substring(0, 30);
            }
            if(this.isDetailAddressError)
            {
                this.isDetailAddressError = false;
                // this.contentsSizeUpdate(-22)
            }
        },
        addressDescription: function()
        {
            if(this.addressDescription.length > 30)
            {
                this.addressDescription = this.addressDescription.substring(0, 30);
            }
        },
        addressNickname: function()
        {
            if(this.addressNickname.length > 10)
            {
                this.addressNickname = this.addressNickname.substring(0, 10);
            }

            if(this.isAddressNicknameError)
            {
                this.isAddressNicknameError = false;
                // this.contentsSizeUpdate(-22)
            }
        }
    }
}
</script>

<style scoped>
    .modal {
        position: fixed;
        background: rgba(0, 0, 0, 0.7);
        max-width: 600px;
        width: 100%;
        height: 100vh;
        z-index: 10;
        bottom: 0;
        box-sizing: border-box;
    }
    .touch {
        width: 100vw;
        height: calc(100vh - 536.8px);
    }
    .contents {
        background: #FFFFFF;
        width: 100%;
        height: 536.8px;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        padding: 30px 16px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
    }
    .title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px; /* 116.667% */
    }
    .input-big {
        width: 100%;
        height: 54px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        box-sizing: border-box;
    }
    input::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }

    .search-address-button {
        border-radius: 6px;
        background: var(--Gray-100, #1E1E1E);
        width: 92px;
        height: 54px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 100% */
        margin-left: 8px;;
    }
    .row {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .apply {
        width: 100%;
        height: 56px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border-radius: 6px;
        background: #184FA1;
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .cancel {
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
         width: 100%;
        height: 56px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    .error-info-text{
        color: var(--Semantic-01_Red, #FF000F);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 100% */
        margin-top: 4px;
    }
    input:disabled {
        background: none;
        color: inherit;
        opacity: 1;
        -webkit-text-fill-color: currentColor; /* Safari에서 흐릿한 회색 텍스트 방지 */
        cursor: default;
    }
    .postcode-layer {
        /* .modal 과 동일하게 left/right 없이 static position 기준으로 정렬합니다. */
        position: fixed;
        top: 0;
        bottom: 0;
        width: 100%;
        max-width: 600px;
        background: #FFFFFF;
        z-index: 100;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
    }
    .postcode-header {
        flex: none;
        height: 56px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px;
        box-sizing: border-box;
        border-bottom: 1px solid var(--Gray-20, #F3F5F8);
    }
    .postcode-title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
    .postcode-close {
        width: 22px;
        cursor: pointer;
    }
    .postcode-embed {
        flex: 1;
        min-height: 0;
        width: 100%;
    }
    .info-text {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        margin-top: 4px;
    }
</style>


// WEBPACK FOOTER //
// src/components/modals/AddressModal.vue